<template>
  <button
    type="button"
    size="large"
    @click="userMenu!.toggle"
  >
    <PrmAvatar :label="initials" />
  </button>

  <PrmMenu
    ref="userMenu"
    popup
    :model="items"
    style="width: 18rem;"
  >
    <template #start>
      <div style="padding: 16px; font-weight: bold;">
        <PrmAvatar :label="initials" />
        <span style="padding-left: 8px;">{{ userName || '' }}</span>
      </div>
    </template>

    <template
      #item="{
        item, props,
      }"
    >
      <router-link
        v-if="item.routeName"
        v-slot="{
          href, navigate,
        }"
        :to="item.routeName"
        custom
      >
        <a
          v-ripple
          :href="href"
          v-bind="props.action"
          class="navbar-header__menu-item"
          :style="item.style"
          @click="navigate"
        >
          <span :class="item.icon" />
          <span style="margin-left: 8px;">{{ item.label }}</span>
        </a>
      </router-link>

      <button
        v-else-if="item.command"
        v-ripple
        v-bind="props.action"
        :style="item.style"
        :disabled="(item.disabled as (boolean | undefined))"
        type="button"
        class="navbar-header__menu-item"
        style="width: 100%;"
      >
        <span
          v-if="item.icon"
          :class="item.icon"
        />
        <component
          :is="item.iconComponent"
          v-if="item.iconComponent"
        />
        <span style="margin-left: 8px;">{{ item.label }}</span>
      </button>

      <div
        v-else
        class="navbar-header__menu-item"
        :style="item.style"
        @hover.capture.stop
        @click.capture.stop
      >
        <span style="margin: 0 16px;">{{ item.label }}</span>
      </div>
    </template>

    <template #end>
      <div style="padding: 16px; display: flex; justify-content: flex-end;">
        <span style="font-weight: bold;">{{ packageInfo.version }}</span>
      </div>
    </template>
  </PrmMenu>
</template>

<script setup lang="ts">
import PrmAvatar from '@NitrexGroup/primevue/avatar';
import PrmMenu from '@NitrexGroup/primevue/menu';
import {
  computed,
  shallowRef,
} from 'vue';

import packageInfo from '@/../package.json';
import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import {
  useAppStore,
} from '@/store/pinia/app.ts';
import {
  getUserInitials,
} from '@/utils/user-util.ts';

const appStore = useAppStore();
appStore.loadCurrentUser();

const userName = computed<string | undefined>(() => `${appStore?.user?.firstName || ''} ${appStore?.user?.lastName || ''}`);
const initials = computed<string | undefined>(() => getUserInitials(appStore?.user?.firstName, appStore?.user?.lastName));
const userMenu = shallowRef<InstanceType<typeof PrmMenu>>();

const items = computed(() => ([
  {
    separator: true,
  },
  {
    label: 'Log out',
    icon: 'pi pi-sign-out',
    style: {
      color: 'var(--error-color)',
    },
    command: () => keycloakAuthenticationHandler.logout(),
  },
  {
    separator: true,
  },
]));
</script>

<style scoped lang="scss">
button {
  background-color: transparent;
  border-style: none;
  cursor: pointer;
  color: inherit;
}

.navbar-header__menu-item {
  text-align: start;
  word-break: break-word;

  svg {
    width: 16px;
    height: 16px;
  }
}
</style>
